import useStyles from './InfiniteListWrapper.styles'

export const InfiniteListWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>{children}</div>
    </div>
  )
}
